const postProductData = (productData,) => {
  
  return (dispatch, getState) => {
    dispatch({ type:'addproductTocart', payload: { productData, } });

  };
};
const decreaseQuantity=(productData,quantity)=>{
   return(dispatch,getState)=>{
    
    dispatch({type:'DecreaseQuantity',payload:{productData}})
   }
}
const cartRemove = (productData,) => {
  
    return(dispatch,getState)=>{
      dispatch({ type: "RemoveItem", payload: productData._id });
    }
};

const cartTotal = (subtotal) => {
  return (dispatch) => {
    dispatch({ type: "CarttotalAmount", payload: subtotal });
  };
};
const userDetails = (userDetailsData) => {
  
  return (dispatch) => {
    dispatch({ type: "SET_USERDETAILS", payload: userDetailsData });
  };
};
const paymentTotal = (payment) => {
  
  return (dispatch) => {
    dispatch({ type: "payment_TotalAmount", payload: payment });
  };
};

const totalProduct = (totalproducts) => {
  
  return (dispatch) => {
    dispatch({ type: "cardTotalProduct", payload: totalproducts });
  };
};
const filterProducts = (productCategory) => {
  return (dispatch) => {
    dispatch({ type: "filterProductData", payload: productCategory });
  };
};
const sliderPricedata = (price) => {
  return (dispatch) => {
    dispatch({ type: "filterProductPrice", payload: price });
  };
};
const userLogOut=()=>{
  return(dispatch)=>{
    dispatch({type:"logoutDetails",payload:{}})
  }

}
const cartTotalpayableAmount=(data)=>{
  return(dispatch)=>{
    
    dispatch({type:'totalCart_Amount',payload:data})
  }
}

const successCartEmpty=()=>{
  return(dispatch)=>{
    dispatch({type:'successorder',payload:{}})
  }
}
// Action to update brand filters
const setBrandFilter = (brand, checked) => ({
  type: 'SET_BRAND_FILTER',
  payload: { brand, checked },
});

// Action to update sort filter
const setSortFilter = (sortOrder) => ({
  type: 'SET_SORT_FILTER',
  payload: sortOrder,
});
const setPriceFilter = (price) => ({
  type: 'SET_PRICE_FILTER',
  payload: price,
});
const resetFilter = () => ({
  type: 'RESET_FILTER'
});

export {
  postProductData,
  cartRemove,
  cartTotal,
  userDetails,
  paymentTotal,
  totalProduct,
  filterProducts,
  sliderPricedata,
  userLogOut,
  cartTotalpayableAmount,
  decreaseQuantity,
  successCartEmpty,
  setBrandFilter,
  resetFilter,
  setSortFilter,
  setPriceFilter
};
